import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { English } from './language/en/index';
import { Spanish } from './language/es/index';

const resources = {
  en: {
    translation: English,
  },
  es: {
    translation: Spanish,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
